import { CalendarClock } from "lucide-react";
import { when } from "@/lib/rides";
import { toLocalInput } from "@/components/booking/TripOptions";
import { Button } from "@/components/ui/button";

export function ScheduleNotice({ schedule, setOpts, admin }) {
  if (!schedule || schedule.ok) return null;
  const p = schedule.problems[0];
  const more = schedule.problems.length > 1 ? ` ${schedule.problems.length} dates in this series are affected.` : "";
  return (
    <div className={`space-y-2 rounded-2xl border p-3 text-sm ${admin ? "border-amber-400/40 bg-amber-400/10 text-amber-100" : "border-destructive/40 bg-destructive/10"}`}
      data-testid="schedule-notice">
      <p className="flex items-start gap-2 font-semibold" data-testid="schedule-notice-message">
        <CalendarClock className="mt-0.5 h-4 w-4 shrink-0" />
        <span>{p.reason === "too_soon" ? p.message : `That time isn't available. ${p.message}.`}{more}</span>
      </p>
      <p className="text-xs" data-testid="schedule-next-available">Next available pickup: <span className="font-semibold">{when(p.next_available)}</span></p>
      <div className="flex flex-wrap items-center gap-2">
        <Button size="sm" variant="outline" className="rounded-full" data-testid="use-next-available-button"
          onClick={() => setOpts((o) => ({ ...o, when: "later", scheduledAt: toLocalInput(p.next_available) }))}>
          Use this time
        </Button>
        {admin && <span className="text-xs">Admins can still book. You'll be asked to confirm.</span>}
      </div>
    </div>
  );
}
